module.exports = __webpack_public_path__ + "static/media/daring-coachella.4b822291.png";